// UserProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const UserProtectedRoute = ({ isAuthenticated, children }) => {
  const fullUrl = window.location.href;
//  console.log("url" , fullUrl);
  if (!isAuthenticated) {
    return <Navigate 
      to="/signin" 
      state={{ from: fullUrl }}
      replace 
    />;
  }

  return children;
};

export default UserProtectedRoute;